import React, { ReactNode } from 'react';
import { FlexItem, FlexPanel } from '../../components/layout/flexpanel';
import { ModalPaddingType } from './Modal';
import { Heading } from '../../components/display/heading';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import { isReactText } from '../../utils';

export interface ModalHeaderProps {
   title?: ReactNode;
   padding: ModalPaddingType;
   onClose?: () => void;
}

export const ModalHeader = (props: ModalHeaderProps) => {

   const title = !props.title || isReactText(props.title) ?
                 <Heading level={4} className='uf-modal-header-title'>
                     {props.title || ''}
                 </Heading> : <div>{props.title}</div>;

   return (
      <FlexPanel
         className={'uf-modal-header'}
         alignItems={'center'}
         paddingLeft={'medium'}
         paddingRight={'medium'}
         paddingTop={'medium'}
         paddingBottom={'medium'}
      >
         <FlexItem flex={1} className={'uf-modal-header-title'}>
            {title}
         </FlexItem>

         {props.onClose && <div onClick={props.onClose} className={'uf-modal-header-close-button'}>
            <CloseOutlined className={'uf-modal-header-close-button-icon'}/>
         </div>}
      </FlexPanel>
   );
};
